import FortuneWheelReport from "./FortuneWheelReport";

export default FortuneWheelReport;
